import { render, staticRenderFns } from "./PhotoBookLayoutTemplateSelection.vue?vue&type=template&id=6456cf36"
import script from "./PhotoBookLayoutTemplateSelection.vue?vue&type=script&lang=js"
export * from "./PhotoBookLayoutTemplateSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports